export default "__VITE_ASSET__5a5940c6__"